import { MyParadiseOverviewButton } from "@app/components/myParadise/MyParadiseOverviewButton/MyParadiseOverviewButton"
import { MyParadiseBluphoria } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseBluphoria/MyParadiseBluphoria"
import { MyParadiseMyData } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseMyData/MyParadiseMyData"
import { MyParadiseOrderHistory } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseOrderHistory/MyParadiseOrderHistory"
import { MyParadisePreferredPayment } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadisePreferredPayment/MyParadisePreferredPayment"
import { MyParadiseTransponder } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseTransponder/MyParadiseTransponder"
import { MyParadiseVouchers } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseVouchers/MyParadiseVouchers"
import { MyParadiseProfileImage } from "@app/components/myParadise/MyParadiseProfileImage/MyParadiseProfileImage"
import Page from "@app/components/pageTypes/Page/Page"
import MyParadiseDataModal from "@app/modals/MyParadise/MyParadiseDataModal/MyParadiseDataModal"
import MyParadiseOrderHistoryModal from "@app/modals/MyParadise/MyParadiseOrderHistoryModal/MyParadiseOrderHistoryModal"
import { MyParadisePreferredPaymentModal } from "@app/modals/MyParadise/MyParadisePreferredPaymentModal/MyParadisePreferredPayment"
import { MyParadiseTransponderModal } from "@app/modals/MyParadise/MyParadiseTransponderModal/MyParadiseTransponderModal"
import { useGetStrings } from "@app/store/service/cmsService"
import { IframeMessages } from "@app/utils/constants"
import { useModal } from "@tecreation/funnel-components"

import MyParadiseEmployeeNews from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseEmployeeNews/MyParadiseEmployeeNews"
import MyParadiseEmployeePoints from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseEmployeePoints"
import SavedPaymentModal from "@app/modals/MyParadise/MyParadiseSavedPaymentModal/MyParadiseSavedPaymentModal"
import { appStore } from "@app/store/store"
import { getUrl } from "@app/utils/htmlUtils"
import { useSelector } from "@tecreation/js-state-react"
import { domAnimation, LazyMotion } from "framer-motion"
import { useEffect } from "react"

import { MyParadiseFunnel } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseFunnel/MyParadiseFunnel"
import { MyParadiseThermencard } from "@app/components/myParadise/MyParadiseOverviewEntries/MyParadiseThermencard/MyParadiseThermencard"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { MyParadiseThermencardModal } from "@app/modals/MyParadise/MyParadiseThermencardModal/MyParadiseThermenCardModal"
import "./MyParadiseOverview.css"

const Row = ({ children }) => {
	return <div className="flex myParadiseOverviewRow h-100">{children}</div>
}

export const MyParadiseOverview = () => {
	const relationPaymentToken = useSelector(state => state.core.relationPaymentToken)
	const success = useSelector(state => state.core.returnStatusPayment)
	const { showModal } = useModal()
	const { push } = useCustomNavigation()
	const {
		data: {
			myParadiseOverviewLabelVoucher,
			myParadiseOverviewLabelTransponder,
			myParadiseOverviewLabelPayment,
			myParadiseOverviewLabelData,
			myParadiseOverviewLabelHistory,
			myParadiseOverviewLabelEntrance,
			myParadiseOverviewLabelThermencard,
		},
	} = useGetStrings(undefined, { defaultData: {} })
	const relation = useSelector(state => state.core.relation)

	const funnelLabelFunc = () => {
		if (window.self !== window.top) {
			let url = appStore.get("core.languageCode") + "/shop/mtp/funnel-eintritt.php"
			const base = getUrl()
			window.parent.postMessage(IframeMessages.openUrl + ";" + (base + url), "*")
		} else {
			push("/")
		}
	}
	const voucherLabelFunc = () => {
		if (window.self !== window.top) {
			let url = appStore.get("core.languageCode") + "/shop/gutscheine/eintrittsgutscheine/"
			const base = getUrl()
			window.parent.postMessage(IframeMessages.openUrl + ";" + (base + url), "*")
		} else {
			alert("can not open vouchers if the window is not in an iframe")
		}
	}
	const bluphoriaLabelFunc = () => {
		let url = "https://bluphoria.de"
		if (window.self !== window.top) {
			window.parent.postMessage(IframeMessages.openUrl + ";" + url, "*")
		} else {
			window.open(url)
		}
	}
	useEffect(() => {
		if (relationPaymentToken) {
			showModal(SavedPaymentModal, { saved: success })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<LazyMotion features={domAnimation}>
			<Page className="px-4 px-md-8 container-xl">
				<div className="flex flex-center">
					<MyParadiseProfileImage />
				</div>

				{relation && relation.tags && relation.tags.filter(e => e.tag === "Employee").length > 0 && (
					<Row>
						<MyParadiseOverviewButton label="News">
							<MyParadiseEmployeeNews />
						</MyParadiseOverviewButton>
						<MyParadiseOverviewButton label="Punktestand">
							<MyParadiseEmployeePoints />
						</MyParadiseOverviewButton>
					</Row>
				)}

				<Row>
					<MyParadiseOverviewButton label={myParadiseOverviewLabelEntrance} labelOnClick={funnelLabelFunc}>
						{/*
						 * We need to provide an image from the cms, therefore we need to create a collection like "MyParadiseFunnelImage".
						 * There need to create entries with an image and a location. Because each collection could have a different image.
						 * We need to load the image for the locationId (the locationId is stored in the appStore)
						 */}
						<MyParadiseFunnel />
					</MyParadiseOverviewButton>
					<MyParadiseOverviewButton label={myParadiseOverviewLabelThermencard} labelOnClick={() => showModal(MyParadiseThermencardModal)}>
						<MyParadiseThermencard />
					</MyParadiseOverviewButton>
				</Row>

				<Row>
					<MyParadiseOverviewButton
						label={myParadiseOverviewLabelHistory}
						labelOnClick={() => {
							showModal(MyParadiseOrderHistoryModal)
						}}
					>
						<MyParadiseOrderHistory />
					</MyParadiseOverviewButton>
					<MyParadiseOverviewButton half label={myParadiseOverviewLabelVoucher} labelOnClick={voucherLabelFunc}>
						<MyParadiseVouchers />
					</MyParadiseOverviewButton>
					<MyParadiseOverviewButton half label={myParadiseOverviewLabelPayment} labelOnClick={() => showModal(MyParadisePreferredPaymentModal)}>
						<MyParadisePreferredPayment />
					</MyParadiseOverviewButton>
				</Row>

				<Row>
					<MyParadiseOverviewButton label="Bluphoria" labelOnClick={bluphoriaLabelFunc}>
						<MyParadiseBluphoria />
					</MyParadiseOverviewButton>
					<MyParadiseOverviewButton label={myParadiseOverviewLabelTransponder} labelOnClick={() => showModal(MyParadiseTransponderModal)}>
						<MyParadiseTransponder />
					</MyParadiseOverviewButton>
				</Row>

				<Row>
					<MyParadiseOverviewButton>{/* Placeholder */}</MyParadiseOverviewButton>
					<MyParadiseOverviewButton label={myParadiseOverviewLabelData} labelOnClick={() => showModal(MyParadiseDataModal)}>
						<MyParadiseMyData />
					</MyParadiseOverviewButton>
				</Row>
			</Page>
		</LazyMotion>
	)
}
